export const DEFAULT_STATE_FETCH_PERIODS = [{ year: '2023', months: [{ value: '2023-01-01', label: 'Январь' }] }];
